import React from "react";
import notify from "devextreme/ui/notify";
import Form, { SimpleItem, GroupItem, Label } from "devextreme-react/form";
import "devextreme-react/text-area";
import { ButtonItem } from "devextreme-react/tree-list";
import UserInfo from "../../UserInfo";
import {
  inserirOuAtualizar,
  criarEntregaNotificacaoDiatDs,
  criarColaboradorDs,
} from "../../DataSources";
import ShowError from "../../AppServices";

const template = {
  id: undefined,
  prefeituraId: undefined,
  emissao: undefined,
  enviadoEm: undefined,
  numero: undefined,
  ano: undefined,
  contribuinteId: undefined,
  tipoId: undefined,
  lote: undefined,
  codigoDeBarras: "",
  status: undefined,
  entregueEm: undefined,
  nomeRecebedor: "",
  tipoDeDocumento: undefined,
  nomeDocumento: "",
  documento: "",
  orgaoEmissor: "",
  entregador: undefined,
  testemunha1: "",
  testemunha2: "",
};

export default class EntregaNotificacaoDiatForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
    template.prefeituraId = UserInfo.getPrefeitura();
    this.entregaNotificacaoDiatDs = criarEntregaNotificacaoDiatDs();

    this.ok = this.ok.bind(this);
    this.cancel = this.cancel.bind(this);
    this.saidaProgramada = false;
  }

  componentDidMount() {
    if (this.props.match.params.id !== undefined) {
      this.entregaNotificacaoDiatDs
        .byKey(this.props.match.params.id)
        .then((data) => {
          if (!data) {
            notify("Notificação de Dívida Ativa não encontrado.", "error");
            this.props.history.push("/entreganotificaodiat");
          }
          this.setState(data);
        })
        .catch((error) => {
          ShowError(error.response.data);
          notify(error, "error", 2000);
          this.props.history.goBack();
        });
    }

    if (this.props.match.params.id === undefined) {
      this.setState({ ...template });
    }
  }

  render() {
    const statusOptions = [
      { id: "0", descricao: "1 - Gerada" },
      { id: "1", descricao: "2 - Enviada" },
      { id: "2", descricao: "3 - Entregue" },
      { id: "3", descricao: "4 - Não Encontrado" },
      { id: "4", descricao: "5 - Recusado" },
    ];

    const tipoDocumentoOptions = [
      { id: "0", descricao: "Nenhum" },
      { id: "1", descricao: "CNPJ" },
      { id: "2", descricao: "CPF" },
      { id: "2", descricao: "RG" },
      { id: "2", descricao: "Outro" },
    ];

    const escolherStatus = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: statusOptions,
      valueExpr: "id",
      displayExpr: "descricao",
    };

    const escolherTipoDocumento = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: tipoDocumentoOptions,
      valueExpr: "id",
      displayExpr: "descricao",
    };

    const escolherColaborador = {
      editorType: "dxSelectBox",
      searchEnabled: true,
      dataSource: criarColaboradorDs(),
      valueExpr: "id",
      displayExpr: "nome",
    };

    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <Form formData={this.state} colCount={2}>
          <GroupItem
            caption="Notificação de Dívida Ativa"
            colSpan={2}
            colCount={2}
          >
            <SimpleItem dataField={"codigoDeBarras"}>
              <Label text="Código de Barras" />
            </SimpleItem>
            <SimpleItem
              dataField={"status"}
              editorType={"dxLookup"}
              editorOptions={escolherStatus}
            >
              <Label text="Status da Notificação" />
            </SimpleItem>
            <SimpleItem
              dataField={"entregueEm"}
              editorType={"dxDateBox"}
              editorOptions={{ width: "100%" }}
            >
              <Label text="Data de Entrega" />
            </SimpleItem>
            <SimpleItem dataField={"nomeRecebedor"}>
              <Label text="Nome do Recebedor" />
            </SimpleItem>
            <SimpleItem
              dataField={"tipoDeDocumento"}
              editorType={"dxLookup"}
              editorOptions={escolherTipoDocumento}
            >
              <Label text="Tipo de Documento" />
            </SimpleItem>
            <SimpleItem dataField={"nomeDocumento"}>
              <Label text="Nome do Documento" />
            </SimpleItem>
            <SimpleItem dataField={"documento"}>
              <Label text="Nº do Documento" />
            </SimpleItem>
            <SimpleItem dataField={"orgaoEmissor"}>
              <Label text="Órgão Emissor" />
            </SimpleItem>
            <SimpleItem
              dataField={"entregadorId"}
              editorType={"dxLookup"}
              editorOptions={escolherColaborador}
            >
              <Label text="Entregador" />
            </SimpleItem>
            <SimpleItem dataField={"testemunha1"}>
              <Label text="Primeira Testemunha" />
            </SimpleItem>
            <SimpleItem dataField={"testemunha2"}>
              <Label text="Segunda Testemunha" />
            </SimpleItem>
          </GroupItem>
        </Form>
        <Form>
          <GroupItem colCount={6}>
            <ButtonItem
              horizontalAlignment={"left"}
              buttonOptions={{
                type: "success",
                text: "Salvar",
                onClick: this.ok,
              }}
            />
            <ButtonItem
              horizontalAlignment={"left"}
              buttonOptions={{
                type: "warn",
                text: "Cancelar",
                onClick: this.cancel,
              }}
            />
          </GroupItem>
        </Form>
      </div>
    );
  }

  ok() {
    const entidade = this.state;
    inserirOuAtualizar(this.entregaNotificacaoDiatDs, entidade)
      .then(
        function () {
          notify(
            "Notificação de Dívida Ativa cadastrado com sucesso.",
            "success"
          );
          this.props.history.goBack();
        }.bind(this)
      )
      .catch((error) => {
        ShowError(error.response.data);
        notify(error, "error", 2000);
      });
  }

  cancel() {
    notify("Operação cancelada", "warning");
    this.props.history.goBack();
  }
}
